/**
 * Bundle Number Plate Configurator
 * Extracted from bundle-drawer.liquid for better maintainability
 * Handles all number plate customization functionality
 */

window.BundleNumberPlate = (function() {
  'use strict';

  // Number plate configuration state
  let numberPlateConfig = {
    front: '',
    back: '',
    design: 'GB',
    frontImageUrl: '',
    backImageUrl: ''
  };

  // Available plate designs
  const plates = {
    'GB': { files: ['great_britain_white', 'great_britain_yellow'], name: '🇬🇧 Great Britain' },
    'England': { files: ['england_white', 'england_yellow'], name: '🏴󠁧󠁢󠁥󠁮󠁧󠁿 England' },
    'Scotland': { files: ['scotland_white', 'scotland_yellow'], name: '🏴󠁧󠁢󠁳󠁣󠁴󠁿 Scotland' },
    'Wales': { files: ['wales_white', 'wales_yellow'], name: '🏴󠁧󠁢󠁷󠁬󠁳󠁿 Wales' },
    'Northern Ireland': { files: ['north_ireland_white', 'north_ireland_yellow'], name: 'Northern Ireland' },
    'Germany': { files: ['germany_white', 'germany_yellow'], name: '🇩🇪 Germany' },
    'Spain': { files: ['spain_white', 'spain_yellow'], name: '🇪🇸 Spain' },
    'France': { files: ['france_white', 'france_yellow'], name: '🇫🇷 France' },
    'Italy': { files: ['italy_white', 'italy_yellow'], name: '🇮🇹 Italy' },
    'Ireland': { files: ['ireland_white', 'ireland_yellow'], name: '🇮🇪 Ireland' },
    'Poland': { files: ['poland_white', 'poland_yellow'], name: '🇵🇱 Poland' },
    'Romania': { files: ['romania_white', 'romania_yellow'], name: '🇷🇴 Romania' },
    'Albania': { files: ['albania_white', 'albania_yellow'], name: '🇦🇱 Albania' },
    'Cyprus': { files: ['cyprus_white', 'cyprus_yellow'], name: '🇨🇾 Cyprus' },
    'Netherlands': { files: ['netherlands_white', 'netherlands_yellow'], name: '🇳🇱 Netherlands' },
    'Portugal': { files: ['portugal_white', 'portugal_yellow'], name: '🇵🇹 Portugal' },
    'Europe': { files: ['european_union_eu_white', 'european_union_eu_yellow'], name: '🇪🇺 Europe' },
    'Bangladesh': { files: ['bangladesh', 'bangladesh'], name: '🇧🇩 Bangladesh' },
    'Turkey': { files: ['turkey', 'turkey'], name: '🇹🇷 Turkey' },
    'Trinidad and Tobago': { files: ['trinidad_and_tobago', 'trinidad_and_tobago'], name: '🇹🇹 Trinidad and Tobago' },
    'Sweden': { files: ['sweden', 'sweden'], name: '🇸🇪 Sweden' },
    'Russia': { files: ['russia', 'russia'], name: '🇷🇺 Russia' },
    'Pakistan': { files: ['pakistan', 'pakistan'], name: '🇵🇰 Pakistan' },
    'Norway': { files: ['norway', 'norway'], name: '🇳🇴 Norway' },
    'Lithuania': { files: ['lithuania', 'lithuania'], name: '🇱🇹 Lithuania' },
    'Latvia': { files: ['latvia', 'latvia'], name: '🇱🇻 Latvia' },
    'Jamaica': { files: ['jamaica', 'jamaica'], name: '🇯🇲 Jamaica' },
    'India': { files: ['india', 'india'], name: '🇮🇳 India' },
    'Hungary': { files: ['hungary', 'hungary'], name: '🇭🇺 Hungary' },
    'Finland': { files: ['finland', 'finland'], name: '🇫🇮 Finland' },
    'Estonia': { files: ['estonia', 'estonia'], name: '🇪🇪 Estonia' },
    'Denmark': { files: ['denmark', 'denmark'], name: '🇩🇰 Denmark' },
    'Bulgaria': { files: ['bulgaria', 'bulgaria'], name: '🇧🇬 Bulgaria' },
    'GR': { files: ['GR', 'GR-Yellow'], name: '🇬🇷 Greece' },
    'UA': { files: ['UA', 'UA-Yellow'], name: '🇺🇦 Ukraine' },
    'CF': { files: ['CF', 'CF-Yellow'], name: '🇨🇫 Central African Republic' },
    'ZA': { files: ['ZA', 'ZA-Yellow'], name: '🇿🇦 South Africa' },
    'GH': { files: ['GH', 'GH-Yellow'], name: '🇬🇭 Ghana' },
    'BR': { files: ['BR', 'BR-Yellow'], name: '🇧🇷 Brazil' },
    'SI': { files: ['SI', 'SI-Yellow'], name: '🇸🇮 Slovenia' },
    'SK': { files: ['SK', 'SK-Yellow'], name: '🇸🇰 Slovakia' },
    'NG': { files: ['NG', 'NG-Yellow'], name: '🇳🇬 Nigeria' },
    'US': { files: ['US', 'US-Yellow'], name: '🇺🇸 United States of America' },
    'CN': { files: ['CN', 'CN-Yellow'], name: '🇨🇳 China' },
    'RS': { files: ['RS', 'RS-Yellow'], name: '🇷🇸 Serbia' }
  };

  const cdnBase = 'https://cdn.shopify.com/s/files/1/1900/2575/t/47/assets/';
  let saveStateTimeout = null;

  // Initialize config from existing state if available
  function init(existingConfig) {
    if (existingConfig) {
      numberPlateConfig = { ...existingConfig };
    }
  }

  // Get current configuration
  function getConfig() {
    return { ...numberPlateConfig };
  }

  // Set configuration
  function setConfig(config) {
    numberPlateConfig = { ...config };
  }

  // Update save button state
  function updateSaveButtonState() {
    const saveButton = document.querySelector('#BundleDrawer button[onclick="saveNumberPlateConfig()"]');
    if (saveButton) {
      const isComplete = numberPlateConfig.front && numberPlateConfig.back;
      saveButton.disabled = !isComplete;
    }
  }

  // Update front plate text
  function updateFront(value) {
    numberPlateConfig.front = value.toUpperCase();

    const frontPreview = document.querySelector('#BundleDrawer #frontText');
    if (frontPreview) {
      frontPreview.textContent = numberPlateConfig.front || '';
      const frontSize = Math.max(16, 32 - 2 * numberPlateConfig.front.length);
      frontPreview.style.fontSize = frontSize + 'px';
    }

    updateSaveButtonState();

    clearTimeout(saveStateTimeout);
    saveStateTimeout = setTimeout(() => {
      if (window.saveBundleState) {
        window.saveBundleState();
      }
    }, 500);
  }

  // Update back plate text
  function updateBack(value) {
    numberPlateConfig.back = value.toUpperCase();

    const backPreview = document.querySelector('#BundleDrawer #backText');
    if (backPreview) {
      backPreview.textContent = numberPlateConfig.back || '';
      const backSize = Math.max(16, 32 - 2 * numberPlateConfig.back.length);
      backPreview.style.fontSize = backSize + 'px';
    }

    updateSaveButtonState();

    clearTimeout(saveStateTimeout);
    saveStateTimeout = setTimeout(() => {
      if (window.saveBundleState) {
        window.saveBundleState();
      }
    }, 500);
  }

  // Update design
  function updateDesign(value) {
    numberPlateConfig.design = value;

    // Update preview images without re-rendering entire form
    const selectedPlate = plates[numberPlateConfig.design] || plates['GB'];
    const frontImageUrl = cdnBase + selectedPlate.files[0] + '.svg';
    const backImageUrl = cdnBase + selectedPlate.files[1] + '.svg';

    const frontImage = document.querySelector('#BundleDrawer .plate-preview__plate:first-child .plate-preview__image');
    const backImage = document.querySelector('#BundleDrawer .plate-preview__plate:last-child .plate-preview__image');

    if (frontImage) frontImage.src = frontImageUrl;
    if (backImage) backImage.src = backImageUrl;

    numberPlateConfig.frontImageUrl = frontImageUrl;
    numberPlateConfig.backImageUrl = backImageUrl;

    updateSaveButtonState();

    // Save state
    clearTimeout(saveStateTimeout);
    saveStateTimeout = setTimeout(() => {
      if (window.saveBundleState) {
        window.saveBundleState();
      }
    }, 500);
  }

  // Update preview
  function updatePreview() {
    const frontPreview = document.querySelector('#BundleDrawer #frontText');
    const backPreview = document.querySelector('#BundleDrawer #backText');

    if (frontPreview) {
      frontPreview.textContent = numberPlateConfig.front || '';
      const frontSize = Math.max(16, 32 - 2 * numberPlateConfig.front.length);
      frontPreview.style.fontSize = frontSize + 'px';
    }
    if (backPreview) {
      backPreview.textContent = numberPlateConfig.back || '';
      const backSize = Math.max(16, 32 - 2 * numberPlateConfig.back.length);
      backPreview.style.fontSize = backSize + 'px';
    }
  }

  // Render the configurator HTML
  function render() {
    const selectedPlate = plates[numberPlateConfig.design] || plates['GB'];
    numberPlateConfig.frontImageUrl = cdnBase + selectedPlate.files[0] + '.svg';
    numberPlateConfig.backImageUrl = cdnBase + selectedPlate.files[1] + '.svg';

    return `
      <div class="bundle-screen active">
        <div class="bundle-screen__header">
          <h2 class="bundle-screen__title">Customise Number Plate</h2>
        </div>

        <div class="bundle-screen__content">
          <!-- Input Fields -->
          <div class="plate-configurator__form">
            <div class="plate-configurator__input-group">
              <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 0.5rem;">
                <label class="plate-configurator__label" style="margin: 0;">Front Plate Text</label>
                <span id="frontCharCounter" style="font-size: 0.8rem; font-weight: 600; padding: 4px 10px; border-radius: 12px; background: rgb(var(--color-drawer-text) / 0.08); color: rgb(var(--color-drawer-text) / 0.7);">${numberPlateConfig.front ? numberPlateConfig.front.length : 0}/9</span>
              </div>
              <input type="text"
                     id="frontInput"
                     class="plate-configurator__input"
                     maxlength="9"
                     value="${numberPlateConfig.front}"
                     oninput="BundleNumberPlate.updateFront(this.value)"
                     placeholder="e.g. OLIVER">
            </div>

            <div class="plate-configurator__input-group">
              <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 0.5rem;">
                <label class="plate-configurator__label" style="margin: 0;">Back Plate Text</label>
                <span id="backCharCounter" style="font-size: 0.8rem; font-weight: 600; padding: 4px 10px; border-radius: 12px; background: rgb(var(--color-drawer-text) / 0.08); color: rgb(var(--color-drawer-text) / 0.7);">${numberPlateConfig.back ? numberPlateConfig.back.length : 0}/9</span>
              </div>
              <input type="text"
                     id="backInput"
                     class="plate-configurator__input"
                     maxlength="9"
                     value="${numberPlateConfig.back}"
                     oninput="BundleNumberPlate.updateBack(this.value)"
                     placeholder="e.g. OLIVER">
            </div>

            <div class="plate-configurator__input-group">
              <label class="plate-configurator__label">Country Design</label>
              <select id="designInput"
                      class="plate-configurator__select"
                      onchange="BundleNumberPlate.updateDesign(this.value)">
                <optgroup label="United Kingdom">
                  <option value="GB" ${numberPlateConfig.design === 'GB' ? 'selected' : ''}>🇬🇧 Great Britain</option>
                  <option value="England" ${numberPlateConfig.design === 'England' ? 'selected' : ''}>🏴󠁧󠁢󠁥󠁮󠁧󠁿 England</option>
                  <option value="Scotland" ${numberPlateConfig.design === 'Scotland' ? 'selected' : ''}>🏴󠁧󠁢󠁳󠁣󠁴󠁿 Scotland</option>
                  <option value="Wales" ${numberPlateConfig.design === 'Wales' ? 'selected' : ''}>🏴󠁧󠁢󠁷󠁬󠁳󠁿 Wales</option>
                  <option value="Northern Ireland" ${numberPlateConfig.design === 'Northern Ireland' ? 'selected' : ''}>Northern Ireland</option>
                </optgroup>
                <optgroup label="Other Countries">
                  ${Object.keys(plates).filter(k => !['GB', 'England', 'Scotland', 'Wales', 'Northern Ireland'].includes(k)).map(country =>
                    `<option value="${country}" ${numberPlateConfig.design === country ? 'selected' : ''}>${plates[country].name}</option>`
                  ).join('')}
                </optgroup>
              </select>
            </div>
          </div>

          <!-- Live Preview -->
          <div class="plate-preview">
            <h3 class="plate-preview__title">Live Preview</h3>
            <div class="plate-preview__container">
              <!-- Front Plate -->
              <div class="plate-preview__plate">
                <img src="${numberPlateConfig.frontImageUrl}"
                     alt="Front plate"
                     class="plate-preview__image">
                <div id="frontText"
                     class="plate-preview__text"
                     style="font-size: ${Math.max(16, 32 - 2 * numberPlateConfig.front.length)}px;">
                  ${numberPlateConfig.front}
                </div>
              </div>

              <!-- Back Plate -->
              <div class="plate-preview__plate">
                <img src="${numberPlateConfig.backImageUrl}"
                     alt="Back plate"
                     class="plate-preview__image">
                <div id="backText"
                     class="plate-preview__text"
                     style="font-size: ${Math.max(16, 32 - 2 * numberPlateConfig.back.length)}px;">
                  ${numberPlateConfig.back}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  // Initialize character counters
  function initCharCounters() {
    const frontInput = document.getElementById('frontInput');
    const backInput = document.getElementById('backInput');

    if (frontInput) {
      frontInput.addEventListener('input', function() {
        const counter = document.getElementById('frontCharCounter');
        if (counter) {
          counter.textContent = this.value.length + '/9';
        }
      });
    }

    if (backInput) {
      backInput.addEventListener('input', function() {
        const counter = document.getElementById('backCharCounter');
        if (counter) {
          counter.textContent = this.value.length + '/9';
        }
      });
    }
  }

  // Public API
  return {
    init: init,
    getConfig: getConfig,
    setConfig: setConfig,
    render: render,
    updateFront: updateFront,
    updateBack: updateBack,
    updateDesign: updateDesign,
    updatePreview: updatePreview,
    initCharCounters: initCharCounters
  };
})();

// Maintain backward compatibility with global functions
window.updateNumberPlateFront = BundleNumberPlate.updateFront;
window.updateNumberPlateBack = BundleNumberPlate.updateBack;
window.updateNumberPlateDesign = BundleNumberPlate.updateDesign;